export default {
    COUNTRY_CODE: 'Landskode',
    PHONE_NUMBER: 'Telefonnummer',
    MOBILE_NUMBER: 'Mobilnummer',
    ON: 'På',
    OFF: 'Av',
};
